export const IndustryPartnerProgramsData = [
  {
    id: "1",
    title: "Full-Stack Web Development Bootcamp",
    description: "Comprehensive program covering React, Node.js, databases, and deployment. Build real-world applications and portfolio projects.",
    sector: "Technology",
    format: "Hybrid",
    duration: "12 weeks",
    price: "$2,999",
    participants: 24,
    rating: 4.8,
    skills: ["React", "Node.js", "JavaScript", "SQL"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "2",
    title: "Digital Marketing Mastery",
    description: "Learn modern digital marketing strategies including SEO, social media, content marketing, and analytics.",
    sector: "Marketing",
    format: "Online",
    duration: "8 weeks",
    price: "$1,299",
    participants: 45,
    rating: 4.6,
    skills: ["SEO", "Social Media", "Analytics", "Content Strategy"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "3",
    title: "Data Science & Analytics",
    description: "Master data analysis, machine learning, and statistical modeling using Python and R.",
    sector: "Technology",
    format: "Online",
    duration: "12 weeks",
    price: "$2,499",
    participants: 32,
    rating: 4.9,
    skills: ["Python", "Machine Learning", "Statistics", "Data Viz"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "4",
    title: "UX/UI Design Intensive",
    description: "Create beautiful, user-centered designs with hands-on projects and real client work.",
    sector: "Design",
    format: "Onsite",
    duration: "8 weeks",
    price: "$1,899",
    participants: 18,
    rating: 4.7,
    skills: ["Figma", "User Research", "Prototyping", "Design Systems"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "5",
    title: "Project Management Professional",
    description: "Become a certified project manager with Agile, Scrum, and traditional methodologies.",
    sector: "Business",
    format: "Hybrid",
    duration: "4 weeks",
    price: "$899",
    participants: 28,
    rating: 4.5,
    skills: ["Agile", "Scrum", "Leadership", "Risk Management"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "6",
    title: "Cybersecurity Fundamentals",
    description: "Learn essential cybersecurity concepts, threat analysis, and security implementation strategies.",
    sector: "Technology",
    format: "Online",
    duration: "8 weeks",
    price: "$1,699",
    participants: 22,
    rating: 4.8,
    skills: ["Network Security", "Threat Analysis", "Compliance", "Risk Assessment"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  },
  {
    id: "7",
    title: "Cybersecurity Fundamentals 2",
    description: "Learn essential cybersecurity concepts, threat analysis, and security implementation strategies.",
    sector: "Technology",
    format: "Online",
    duration: "8 weeks",
    price: "$1,699",
    participants: 22,
    rating: 4.8,
    skills: ["Network Security", "Threat Analysis", "Compliance", "Risk Assessment"],
    image: "/images/industry-partner-programs/program-fullstack.jpg",
    link: "#",
    applyLink: "#"
  }
]